import { hasResetDate, isAdditional, isGb } from "./common";
var pickNextIfGb = function pickNextIfGb(current, next) {
  return isGb(next) ? next : current;
};
export var findClosestExpiringAdditionalAccumulator = function findClosestExpiringAdditionalAccumulator(accumulators) {
  return accumulators === null || accumulators === void 0 ? void 0 : accumulators.reduce(function (result, next) {
    if (isAdditional(next) && hasResetDate(next) && result !== null && result !== void 0 && result.resetDate) {
      if (Date.parse(result.resetDate) === Date.parse(next.resetDate)) {
        return pickNextIfGb(result, next);
      }
      return Date.parse(result.resetDate) > Date.parse(next.resetDate) ? next : result;
    }
    if (isAdditional(next) && hasResetDate(next) && !(result !== null && result !== void 0 && result.resetDate)) {
      return next;
    }
    return result;
  }, undefined);
};